import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import useCourse from '../Hooks/useCourse';
import InfoIcon from '@mui/icons-material/LightbulbOutlined';

export default function FifplButton(){

    const course = useCourse();

    return course?.enrollment?.type?.id === 'fifpl' &&
        <Link to={`/study/${course.id}/fifpl`}>

            <Button 
                variant='outlined'
                size='small'
                sx={{ml: 1, mt: 1}}
                startIcon={<InfoIcon />}
            >
                Tutoriel FIFPL
            </Button>

        </Link>

}